<template>
    <div class="container">
        <h1>Configure Groups</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="List">
                <b-table
                        v-if="groups.length > 0"
                        :striped="true"
                        :narrowed="true"
                        :data="groups"
                        default-sort="name"
                        default-sort-direction="asc"
                >
                    <template slot-scope="props">
                        <b-table-column label="Group" field="name" sortable>
                            <router-link :to="{path: '/configure/group/' + props.row.id}">{{props.row.name}}</router-link>
                        </b-table-column>
                        <b-table-column label="Objects" numeric>{{props.row.items.length}}</b-table-column>
                    </template>
                </b-table>
            </b-tab-item>
            <b-tab-item label="Add Group">
                <div class="container has-text-left margin_top_1rem">
                    <b-field label="Name">
                        <b-input v-model="name" required placeholder="Enter name for the group"></b-input>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-success" :disabled="!validFields()" @click="handleAddGroup">Create</b-button>
                    </div>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import BTable from "buefy/src/components/table/Table";
    import BTableColumn from "buefy/src/components/table/TableColumn";
    import BField from "buefy/src/components/field/Field";
    import BButton from "buefy/src/components/button/Button";

  export default {
    name: "screenconfiguregroups",
    components: {
      BButton,
      BField,
      BTableColumn,
      BTable
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        prio: 5
      };
    },
    computed: {
      ...mapGetters('objects', ['groups'])
    },
    methods: {
      ...mapActions('objects', ['addGroup']),
      validFields() {
        if (!this.name || this.name.length < 1) {
          return false;
        }
        return true;
      },
      resetFields() {
        this.name = ''
      },
      handleAddGroup() {
        this.addGroup({
          name: this.name
        });
        this.resetFields();
        this.activeTab = 0;
      }
    },
    mounted() {
    }
  }
</script>

<style scoped>
h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}

    .margin_top_1rem {
        margin-top: 1rem;
    }
</style>